// extracted by mini-css-extract-plugin
module.exports = {"ctoButton":"CellularCapability_ctoButton__2dO4V","noHoverBg":"CellularCapability_noHoverBg__39i4Y"};